import axios from 'axios'
import { setWalletDirection, setWallets } from './../reducers/wallets.reducer'

const URL = process.env.REACT_APP_API_PORTAL

// GET wallet credentials from user id credentials (this is not used for now)
export const getWalletCredentials = (id) => async (dispatch) => {
  const token = localStorage.getItem('token')
  const config = {
    method: 'GET',
    url: `${URL}wallet?idclient=${id}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  }

  dispatch(setWallets({ wallets: {}, isLoading: true }))

  axios(config)
    .then((data) => {
      if (data?.status === 200) {
        dispatch(
          setWallets({
            wallets: data?.data?.data?.[0] || null,
            isLoading: false,
            message: data?.data?.message,
            isError: false,
          })
        )
      }
    })
    .catch((error) => {
      dispatch(
        setWallets({
          wallet: {},
          isLoading: false,
          isError: true,
          message: error?.response?.data?.message || 'Error creating wallet',
        })
      )
    })
}

// GET wallet direction from user id credentials (this is used to send or receive tokens)
export const getWalletDirection = (id) => async (dispatch) => {
  dispatch(
    setWalletDirection({
      polygonAddress: null,
      tronAddress: null,
      isLoading: true,
      error: null,
    })
  )

  let url = `${URL}clientesportal/${id}`

  const configDocIden = {
    method: 'GET',
    maxBodyLength: Infinity,
    url,
  }

  axios(configDocIden)
    .then((response) => {
      dispatch(
        setWalletDirection({
          polygonAddress:
            response?.data?.data?.metadata?.namespaces?.eip155?.address,
          tronAddress:
            response?.data?.data?.metadata?.namespaces?.tron?.address,
          isLoading: false,
          error: null,
        })
      )
    })
    .catch((error) => {
      dispatch(
        setWalletDirection({
          polygonAddress: null,
          tronAddress: null,
          isLoading: false,
          error: error?.response?.data?.error,
        })
      )
    })
}
